import Vue from 'vue'
import store from "../store/index"
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

import Main from '@/pages/main'
import Checksuc from '@/pages/checksuccess'
import Mine from '@/pages/mine'
import Ren from '@/pages/ren'
import Bind from '@/pages/login'
import Check from '@/pages/check'
import CheckB from '@/pages/checkBusiness'
import CheckBm from '@/pages/checkBusinessm'
import NotFound from '@/pages/404'
import Contract from '@/pages/contract'
import Checkalready from '@/pages/checkalready'
import Signsuccess from '@/pages/signsuccess'
import GuarantSign from '@/pages/guarantSign'
import Extension from '@/pages/extension'
import EntList from '@/pages/entList'
Vue.use(Router)

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'bind',
      component: Bind,
      meta: {
        title: '登录',
      }
    },
    {
      path: '*',
      component: NotFound,
      meta: {
        title: '404'
      }
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/ren',
      name: 'ren',
      component: Ren,
      meta: {
        title: '认证信息'
      }
    },
    {
      path: '/mine',
      name: 'mine',
      component: Mine,
      meta: {
        title: '我的合同'
      }
    },
    {
      path: '/guarantee/:id',
      name: 'guarantee',
      component: GuarantSign,
      meta: {
        title: '担保合同'
      }
    },
    {
      path: '/extension/:id',
      name: 'extension',
      component: Extension,
      meta: {
        title: '合同要素'
      }
    },
    {
      path: '/check',
      name: 'check',
      component: Check,
      meta: {
        title: '实名认证'
      }
    },
    {
      path: '/entList',
      name: 'entList',
      component: EntList,
      meta: {
        title: '企业实名'
      }
    },
    {
      path: '/checkbusiness/:id',
      name: 'checkb',
      component: CheckB,
      meta: {
        title: '企业实名认证'
      }
    },
    {
      path: '/checkbusinessm/:id',
      name: 'checkbm',
      component: CheckBm,
      meta: {
        title: '企业实名认证'
      }
    },
    {
      path: '/contract/:id',
      name: 'contract',
      component: Contract,
      meta: {
        title: '合同预览'
      }
    },
    {
      path: '/checkalready',
      name: 'checkalready',
      component: Checkalready,
      meta: {
        title: '认证成功'
      }
    },
    {
      path: '/checksuc',
      name: 'checksuc',
      component: Checksuc,
      meta: {
        title: '认证成功'
      }
    },
    {
      path: '/signsuccess',
      name: 'signsuccess',
      component: Signsuccess,
      meta: {
        title: '签约成功'
      }
    },
    ]
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
    if (to.meta.require) {
        if(store.state.phone!=0){
          next();
        }else{
          router.push('/login');
        }
        next()
    } else {
      next();
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js